import React, { useMemo, useState } from 'react';
import '../mobile.css';

export const CATEGORIES = ['Top', 'High', 'Medium', 'Low'];

export const mapUrgencyToTab = (category) => {
  switch (category) {
    case 'Level 1':
      return 'Top';
    case 'Level 2':
      return 'High';
    case 'Level 3':
      return 'Medium';
    default:
      return 'Low';
  }
};

// Shared Top/High/Medium/Low urgency-tab filtering, extracted once instead of
// duplicating the mapUrgencyToTab/tab-bar/filter logic per analysis screen.
export const useUrgencyTabs = (items, categoryOf) => {
  const [activeTab, setActiveTab] = useState('Top');

  const hasUrgency = items.some((item) => {
    const c = categoryOf(item);
    return c !== null && c !== undefined;
  });

  const tabCounts = useMemo(() => {
    const counts = {};
    CATEGORIES.forEach((cat) => {
      counts[cat] = hasUrgency ? items.filter((item) => mapUrgencyToTab(categoryOf(item)) === cat).length : 0;
    });
    return counts;
  }, [items, hasUrgency]); // eslint-disable-line react-hooks/exhaustive-deps

  const visibleItems = useMemo(() => {
    if (!hasUrgency) return items;
    return items.filter((item) => mapUrgencyToTab(categoryOf(item)) === activeTab);
  }, [items, hasUrgency, activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  return { activeTab, setActiveTab, hasUrgency, tabCounts, visibleItems };
};

export const UrgencyTabBar = ({ hasUrgency, activeTab, setActiveTab, tabCounts, badgeCounts }) => {
  if (!hasUrgency) return null;

  return (
    <div className="m-tab-bar">
      {CATEGORIES.map((cat) => {
        const disabled = (tabCounts[cat] || 0) === 0;
        const badge = badgeCounts ? badgeCounts[cat] : 0;
        const isActive = activeTab === cat;
        return (
          <button
            key={cat}
            className={`m-tab${isActive ? ' active' : ''}`}
            disabled={disabled}
            onClick={() => setActiveTab(cat)}
            style={disabled ? { opacity: 0.5 } : undefined}
          >
            <span>{cat}</span>
            <span className="m-tab-count" style={{ background: isActive ? '#ffffff' : 'grey', color: isActive ? '#094268' : '#ffffff' }}>
              {badge}
            </span>
          </button>
        );
      })}
    </div>
  );
};
